import { NewDialogProps } from "../components/dialog/NewCustomDialog";
import { CreateLabelsButton } from "../components/buttons/CreateLabelsButton";

interface createLabelButtonMakerArgs {
    setModalProps: React.Dispatch<React.SetStateAction<NewDialogProps>>,
    dialogTitle: string,
    dialogDetail: string,
    buttonLabel: string,
    functionality: string,
    actionsToExecute?: Function,
    isAdminFunctionality?: boolean,
    customFunctionalitiesList?: {}[],
  }

export const createLabelButtonMaker = ({
    setModalProps,
    dialogTitle,
    dialogDetail,
    buttonLabel,
    functionality,
    actionsToExecute,
    isAdminFunctionality,
    customFunctionalitiesList,
  }: createLabelButtonMakerArgs): React.ReactNode => CreateLabelsButton({
    setModalProps,
    dialogTitle,
    dialogDetail,
    buttonLabel,
    functionality,
    actionsToExecute,
    isAdminFunctionality,
    customFunctionalitiesList,
  });